import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

type QRResult = { value: string; width: number; src: string | null };

export const useQRCode = (value: string | null, width = 180) => {
  const [result, setResult] = useState<QRResult | null>(null);
  const matches = result?.value === value && result?.width === width;
  const src = matches ? result.src : null;
  const isLoading = Boolean(value && !matches);

  useEffect(() => {
    if (!value) {
      return;
    }

    let active = true;

    const generate = async () => {
      let src: string | null;

      try {
        src = await QRCode.toDataURL(value, { width, margin: 1 });
        const image = new Image();
        image.src = src;
        await image.decode?.();
      } catch {
        src = null;
      }

      if (active) {
        setResult({ value, width, src });
      }
    };

    void generate();

    return () => {
      active = false;
    };
  }, [value, width]);

  return { src, isLoading };
};
